let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fsnzn")).then(() => parcelRequire('4vVNg'));